module.exports = __webpack_public_path__ + "img/horizontal_7_7_3.8d039293.png";